interface AnalyticsSDK {
  track: (
    eventName: string,
    metadata: Record<string, any>,
    customerId?: string,
    mauticId?: string,
  ) => Promise<void>;
}

interface CreateSDK {
  createSDK: (config: { clientKey: string; url: string }) => Promise<AnalyticsSDK>;
}

let sdk: AnalyticsSDK | null = null;
let initPromise: Promise<AnalyticsSDK> | null = null;

export function getAnalyticsUrl(hostname?: string): string {
  const host = (
    hostname ?? (typeof window !== "undefined" ? window.location.hostname : "")
  ).toLowerCase();
  if (host.includes("satumeja")) {
    return "https://analytics.satumeja.co.id";
  }
  return "https://analytics.dailyaffair.co.id";
}

export async function initSDK(): Promise<AnalyticsSDK> {
  initPromise = (async () => {
    try {
      const analyticsUrl = getAnalyticsUrl();
      const { createSDK } = (await import(/* @vite-ignore */ `${analyticsUrl}/sdk.js`)) as CreateSDK;
      sdk = await createSDK({
        clientKey: "c9f5f953-27bd-4f71-b24d-abdd52cb4b10",
        url: analyticsUrl,
      });
      return sdk;
    } catch (error) {
      console.error("Failed to load analytics SDK:", error);
      throw error;
    } finally {
      initPromise = null;
    }
  })();
  return initPromise;
}

export async function getSDK(): Promise<AnalyticsSDK> {
  if (sdk) {
    return sdk;
  }
  if (initPromise) {
    return await initPromise;
  }

  return await initSDK();
}

export async function trackEvent(
  eventName: string,
  metadata: Record<string, any>,
  customerId?: string,
  mauticId?: string,
) {
  try {
    const analyticsSDK = await getSDK();
    await analyticsSDK.track(eventName, metadata, customerId, mauticId);
  } catch (error) {
    console.error("Failed to send tracking event:", error);
  }
}